module.exports = __webpack_public_path__ + "static/media/Drawdown2StoppingClimateChange.f1daa64b.jpg";